import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-shop-single-product-view',
  templateUrl: './shop-single-product-view.component.html',
  styleUrls: ['./shop-single-product-view.component.scss']
})
export class ShopSingleProductViewComponent implements OnInit {
  
  pageName = "Shop / Product Details";
  modelName = "Product";
  product: any;
  reviews = [];
  averageReviews = 0
  numberOfReviews = 0
  upsellProducts = []
  loading = false
  prodId = '';
  images = []
  selectedImage = 0
  productDifSizes = []
  productDifColors = []
  productFound = false

  p: number = 1;
  itemsPerPage = 5;

  color = ''
  size = ''
  quantity = 1

  modelForm: FormGroup;


  constructor(
    private router: Router,
    private _data: CommonDataService,
    private _ecom: CommerceDataService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
  ) { 


    this.route.params.subscribe((params) => {

      if(params['id']) {
        this.prodId = params['id'];
      } 
    });

    let queryData = new FormData();
    queryData.append('modelName', this.modelName);
    queryData.append('mid', this.prodId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.product = data['covers'][0];
          this.getProductImageSrc(this.product)
          this.getProductReviews()
          this.loading = false
          this.productFound = true


          let h = {
            class: "iziToast-info",
            title:  "Success:",
            message:  "product retrieved",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 3200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

        },
        error => {

          console.log(error);
        //   iziToast.success({
        //     title: 'Error!',
        //     position: 'topRight',
        //     icon: 'icon-circle-check',
        //     message: 'Failed to get products.'
        // });

        let h = {
          class: "iziToast-danger",
          title:  "Failed",
          message:  "to get product info",
          animateInside: !1,
          position: "topRight",
          progressBar: !1,
          icon: "icon-ban",
          timeout: 3200,
          transitionIn: "fadeInLeft",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeIn",
          transitionOutMobile: "fadeOut",
        };
        iziToast.show(h);


        $('#loader').hide();

        },

        () => {
            $('#loader').hide();
        }
      );
  }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    // $('#owl-initialise').trigger('click');
    $('#owl-initialise').trigger('click');

    this.modelForm = this.formBuilder.group({

      review_name: ['', Validators.required], 
      review_email: ['', [Validators.required, Validators.email]], 
      review_subject: [''], 
      review_rating: ['', Validators.required], 
      review_text: ['', Validators.required], 
    });

    
  }

  selectImage(i) {
    this.selectImage = i
  }

  getProductImageSrc(modelData){

    if( modelData['cover']['model']['modelData']['formFieldsEntities']['files'] && modelData['cover']['model']['modelData']['formFieldsEntities']['files']['uploads'] && Array.isArray(modelData['cover']['model']['modelData']['formFieldsEntities']['files']['uploads']) && modelData['cover']['model']['modelData']['formFieldsEntities']['files']['uploads'].length > 0) {
      let productImages = modelData['cover']['model']['modelData']['formFieldsEntities']['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          // return src
          this.images.push(src)
        }
        
      }

    }
  }

  getProductReviews() {
    let queryData = new FormData();
    queryData.append('modelName', 'ProductReview');
    queryData.append('reviewDetails->productId', this.prodId);

      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          if(data['covers'].length > 0 ) {
              this.reviews = data['covers']
              this.numberOfReviews = data['covers'].length
          }


        },
        error => {},

        () => {
        }
      );
  }

  isProductMultisize(sizevariations) {
    let productvariations = JSON.parse(sizevariations)
    let sizes = []

    if(productvariations.length > 0) {

      for (let index = 0; index < productvariations.length; index++) {
        const element = productvariations[index];
        
        if(element['size'] && element['size'] != '' && !sizes.includes(element['size'])) {
          sizes.push(element['size'])
        }
      }
    }

    if(sizes.length > 0) {
      this.productDifSizes = sizes
      return true
    }

    else 
      return false
  }

  isProductMultiColors(sizevariations) {

    let productvariations = JSON.parse(sizevariations)
    let colors = []

    if(productvariations.length > 0) {

      for (let index = 0; index < productvariations.length; index++) {
        const element = productvariations[index];
        
        if(element['color'] && element['color'] != '' && !colors.includes(element['color'])) {
          colors.push(element['color'])
        }
      }
    }

    if(colors.length > 0) {
      this.productDifColors = colors
      return true

    }

    else 
      return false
  }

  getVariationId(size, color) {

    let productvariations = JSON.parse(this.product['cover']['model']['modelData']['formFieldsEntities']['productDetails']['sizevariations'])
    let variationId = 0

    if(productvariations.length > 1) {

      for (let index = 0; index < productvariations.length; index++) {
        const element = productvariations[index];
        
        if(element['size'] && element['size'] == size && element['color'] && element['color'] == color) {
          variationId = index
        }
      }
    }

    return variationId
  }

  addProductToShoppingCart() {
    //check if its an instant cart add 
    if(this._ecom.checkInstantAddToCart(this.product)) {
      this.product['variationId'] = 0
      this._ecom.addToShoppingCart(this.product, this.quantity)
    }

    else {
      //lets match color and size to the correct product variation
      let productvariations = JSON.parse(this.product['cover']['model']['modelData']['formFieldsEntities']['productDetails']['sizevariations'])
      let variationId = 0
      this.product['variationId'] = 0

      if(productvariations.length > 1) {

        for (let index = 0; index < productvariations.length; index++) {
          const element = productvariations[index];
          
          if(element['size'] && element['size'] == this.size && element['color'] && element['color'] == this.color) {
            variationId = index
            //this is the correct variation id
            this.product['variationId'] = variationId
            this.product['size'] = this.size
            this.product['color'] = this.color
          }
        }
      }

      this._ecom.addToShoppingCart(this.product, this.quantity)

    }
  }

  addToWishlist() {
    this._ecom.getUserWishlistAndAppendNewItem(this.prodId)

  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected')
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Submit Review ');
      $('#loader').hide();
      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createModel(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createModel() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', 'ProductReview');
    modelObject1.append('reviewDetails-review_name', this.modelForm.controls['review_name'].value);
    modelObject1.append('reviewDetails-review_email', this.modelForm.controls['review_email'].value);
    modelObject1.append('reviewDetails-review_subject', this.modelForm.controls['review_subject'].value);

    modelObject1.append('reviewDetails-review_rating', this.modelForm.controls['review_rating'].value);
    modelObject1.append('reviewDetails-review_text', this.modelForm.controls['review_text'].value);
    modelObject1.append('reviewDetails-productId', this.prodId);
    //modelObject1.append('status', this.modelForm.controls['status'].value);

    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {

          this.getProductReviews()
        },
        error => {
          console.log(error);
          $('#buttonText').text('Submit ');
          $('#loader').hide();

        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your review updated successfuly.'
          });

          $('#buttonText').text('Submit Review');
          $('#loader').hide();

        }
      );
  }

}
